import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FlaskConical } from 'lucide-react';
import { dryRunLines } from './dryRunSummary';

/** What pressing an Action would have done, shown while viewing as someone. */
export default function TriedActionDialog({ tried, onClose }) {
  const close = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    close.current?.focus();
    return () => previous?.focus?.();
  }, []);
  const lines = dryRunLines(tried.writes);
  return createPortal(<div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
    <div role="dialog" aria-modal="true" aria-labelledby="tried-action-title" data-testid="tried-action-dialog"
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose();
        // Close is the only control, so focus stays on it.
        if (event.key === 'Tab') { event.preventDefault(); close.current?.focus(); }
      }}
      className="flex max-h-[85vh] w-full max-w-xl flex-col rounded-xl bg-white p-6 shadow-xl">
      <div className="flex items-center gap-2 text-slate-500"><FlaskConical size={16} aria-hidden="true" />{tried.name}</div>
      <h2 id="tried-action-title" className="mt-2 text-lg font-semibold">
        {tried.succeeded ? 'Tried it. Nothing was saved.' : 'This would fail. Nothing was saved.'}
      </h2>
      {tried.succeeded ? (
        lines.length ? <>
          <p className="mt-3 text-sm text-slate-600">For real, this would:</p>
          <ul className="mt-2 list-disc space-y-1 overflow-auto pl-5 text-sm text-slate-800">{lines.map((line, index) => <li key={index}>{line}</li>)}</ul>
        </> : <p className="mt-3 text-sm text-slate-600">{tried.message || 'No records would change.'}</p>
      ) : <p className="mt-3 break-words text-sm text-slate-700">{tried.message}</p>}
      <div className="mt-5 flex justify-end">
        <button ref={close} type="button" className="rounded bg-slate-900 px-4 py-2 text-white" onClick={onClose}>Close</button>
      </div>
    </div>
  </div>, document.body);
}
